import { render } from "./AddMouvementFichePage.vue?vue&type=template&id=225ec082&ts=true"
import script from "./AddMouvementFichePage.vue?vue&type=script&lang=ts"
export * from "./AddMouvementFichePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__